import TagManager from 'react-gtm-module';

interface IUserPageActivity {
  event_category: string;
  event_action: string;
  event_label: string | null;
  event_timestamp: string;
  [rest: string]: any;
}

/**
 * TODO: Deprecate the test function test, for loadPage
 * @returns void
 */
export function loadPage(): void {
  const tagManagerArgs = {
    dataLayer: {
      event: '',
      transaction_dt: '',
      transaction_local_dt: '',
    },
    dataLayerName: 'dataLayer',
  };

  const tzoffset = new Date().getTimezoneOffset() * 60000;
  const transaction_local_date = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);

  tagManagerArgs.dataLayer.event = 'pageview';
  tagManagerArgs.dataLayer.transaction_dt = new Date().toISOString();
  tagManagerArgs.dataLayer.transaction_local_dt = transaction_local_date;

  TagManager.dataLayer(tagManagerArgs);
}

export const pageviewEvent = (
  page_title: string, // page title in the sheet
  product_model_name: string, // Product Model. Ex: Mastering, PVS, Match (TDX)
  message_id: string, // Message Id. Should be in UUID Format
  event_timestamp: string, // Unix Timestamp
  product_platform_code: string, // Product Platform. Ex: GLP, ILP, MASTERING
  business_model_code: string, // Product's Business Model Code. Ex: directToLearner, courseWare
  course_id: string, // Course Id
  course_section_id: string, // Course Section Id
  content_id: string // Content Id
): void => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'pageview',
      page_title: '', // page title in the sheet
      product_model_name: '', // Product Model. Ex: Mastering, PVS, Match (TDX)
      message_id: '', // Message Id. Should be in UUID Format
      transaction_dt: '', // Transaction Date in ISO Format
      transaction_local_dt: '', // Local Timestamp in Format: YYYY-MM-DDThh:mm:ss.ms
      event_timestamp: '', // Unix Timestamp
      product_id: 'MLMAITutor', // Product Id
      product_platform_code: '', // Product Platform. Ex: GLP, ILP, MASTERING
      business_model_code: '', // Product's Business Model Code. Ex: directToLearner, courseWare
      course_id: '', // Course Id
      course_section_id: '', // Course Section Id
      content_id: '', // Content Id
      content_id_type: 'book_code', // Content Id Type
    },
    // dataLayerName: 'MLMAIDataLayer',
  };
  const tzoffset = new Date().getTimezoneOffset() * 60000;
  const transaction_local_date = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);

  tagManagerArgs.dataLayer.page_title = page_title;
  tagManagerArgs.dataLayer.product_model_name = product_model_name;
  tagManagerArgs.dataLayer.message_id = message_id;
  tagManagerArgs.dataLayer.transaction_dt = new Date().toISOString();
  tagManagerArgs.dataLayer.transaction_local_dt = transaction_local_date;
  tagManagerArgs.dataLayer.event_timestamp = event_timestamp;
  tagManagerArgs.dataLayer.product_platform_code = product_platform_code;
  tagManagerArgs.dataLayer.business_model_code = business_model_code;
  tagManagerArgs.dataLayer.course_id = course_id;
  tagManagerArgs.dataLayer.course_section_id = course_section_id;
  tagManagerArgs.dataLayer.content_id = content_id;

  TagManager.dataLayer(tagManagerArgs);
};

export const pageTrackingEvent = ({
  event_category = '',
  event_action = '',
  event_label = null,
  event_timestamp = '',
  ...rest
}: IUserPageActivity) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'user_interaction',
      event_category: '',
      event_action: '',
      event_label: event_label,
      transaction_local_dt: '',
      event_timestamp: '',
      ...rest,
    },
  };
  const tzoffset = new Date().getTimezoneOffset() * 60000;
  const transaction_local_date = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);

  tagManagerArgs.dataLayer.event = 'user_interaction';
  tagManagerArgs.dataLayer.event_category = event_category;
  tagManagerArgs.dataLayer.event_action = event_action;
  tagManagerArgs.dataLayer.transaction_local_dt = transaction_local_date;
  tagManagerArgs.dataLayer.event_timestamp = event_timestamp;

  TagManager.dataLayer(tagManagerArgs);
};

export const telemetrypageErrorEvent = (
  error_code: string, // required
  error_url: string, // optional
  error_message: string, // required
  event_timestamp: string, // Unix Timestamp
  parameter_name: string // Include the parameters required for that spefic event.
) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'exception',
      error_code: '',
      error_url: '',
      error_message: '',
      transaction_local_dt: '',
      event_timestamp: '',
      parameter_name: '',
    },
    // dataLayerName: 'MLMAIDataLayer',
  };
  const tzoffset = new Date().getTimezoneOffset() * 60000;
  const transaction_local_date = new Date(Date.now() - tzoffset).toISOString().slice(0, -1); // Local Timestamp in Format: YYYY-MM-DDThh:mm:ss.ms

  tagManagerArgs.dataLayer.event = 'exception';
  tagManagerArgs.dataLayer.error_code = error_code;
  tagManagerArgs.dataLayer.error_url = error_url;
  tagManagerArgs.dataLayer.error_message = error_message;
  tagManagerArgs.dataLayer.transaction_local_dt = transaction_local_date;
  tagManagerArgs.dataLayer.event_timestamp = event_timestamp;
  tagManagerArgs.dataLayer.parameter_name = parameter_name;

  TagManager.dataLayer(tagManagerArgs);
};
